import { ActionMenu, type ActionMenuItemProps } from "@/components/ActionMenu.tsx";
import { WButton } from "@/components/button/WButton.tsx";
import { savedColorSchemeAtom, type ColorSchemeMode } from "@/modules/main/ColorSchemeSwitcher.store.ts";
import { Trans, useLingui } from "@lingui/react/macro";
import { useAtom } from "jotai/react";

const icons: Record<ColorSchemeMode, string> = {
    light: "jp-brightness-max-icon",
    dark: "jp-brightness-dark-icon",
    auto: "jp-brightness-medium-icon",
};

const items = [
    { id: "light", title: <Trans>Light</Trans>, icon: "jp-brightness-max-icon color-primary size-1rem" },
    { id: "dark", title: <Trans>Dark</Trans>, icon: "jp-brightness-dark-icon color-primary size-1rem" },
    {
        id: "auto",
        title: (
            <Trans comment="Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'">
                Auto
            </Trans>
        ),
        icon: "jp-brightness-medium-icon color-primary size-1rem",
    },
] satisfies ({ id: ColorSchemeMode } & ActionMenuItemProps)[];

export default function ChangeColorSchemeMenu() {
    const { t } = useLingui();
    const [scheme, setScheme] = useAtom(savedColorSchemeAtom);

    return (
        <ActionMenu header={t`Appearance`} onAction={({ id }) => setScheme(id)} selectedKeys={[scheme]} items={items}>
            <WButton
                color="primary"
                variant="ghost"
                size="bar"
                icon={icons[scheme]}
                ariaLabel="Appearance"
                action={undefined}
            />
        </ActionMenu>
    );
}
